function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 41.286,
  y: 38.3448,
  width: 99.5943,
  height: 63.286
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.1818,130.7454a29.4767,29.4767,0,0,1,10.0809-11.0083,2.5216,2.5216,0,0,0,1.1492-2.117V63.6069a15.2008,15.2008,0,0,0-4.4356-10.6958L136.52,18.4951A15.0564,15.0564,0,0,0,125.8242,14.06H29.1891A15.1269,15.1269,0,0,0,14.0678,29.1808v75.6064a5.0423,5.0423,0,0,0,5.0405,5.04h7.5606a2.5211,2.5211,0,0,1,2.52,2.52V132.51a2.5211,2.5211,0,0,1-2.52,2.52H19.1083a5.0423,5.0423,0,0,0-5.04,5.04v75.6064a15.1269,15.1269,0,0,0,15.1213,15.1213H110.33a2.5158,2.5158,0,0,0,2.3892-1.7239,7.5755,7.5755,0,0,1,.504-1.22ZM97.245,49.3425V89.6659a7.5607,7.5607,0,1,1-15.1213,0V49.3425a7.5607,7.5607,0,0,1,15.1213,0Zm-35.283,0V89.6659a7.5607,7.5607,0,1,1-15.1213,0V49.3425a7.5607,7.5607,0,0,1,15.1213,0Zm70.5659,40.3234a7.5606,7.5606,0,1,1-15.1212,0V49.3425a7.5606,7.5606,0,0,1,15.1212,0Z",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 178.2028,
  y: 163.0913,
  width: 25.5578,
  height: 80.9331
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M254.3651,234.8806l-50.9587-97.1088a14.627,14.627,0,0,0-25.8372,0l-50.9587,97.1189a14.4269,14.4269,0,0,0,.4839,14.1938A14.6674,14.6674,0,0,0,139.524,256H241.4515a14.7072,14.7072,0,0,0,12.44-6.9255A14.4528,14.4528,0,0,0,254.3651,234.8806Zm-71.443-59.5275a7.5607,7.5607,0,0,1,15.1213.01v30.2425a7.5607,7.5607,0,0,1-15.1213,0Zm7.5606,63.0155a10.0809,10.0809,0,1,1,10.0809-10.0809A10.0846,10.0846,0,0,1,190.4827,238.3686Z",
  fill: "#ffc02c"
});

var SvgWebappIconSdCardAlertDarkTheme = function SvgWebappIconSdCardAlertDarkTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconSdCardAlertDarkTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-sd-card-alert-dark-theme.43777e2a.svg";
export { ForwardRef as ReactComponent };